/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  GetRpcLatestLocationsForFleetParams,
  PostgrestError,
  RpcLatestLocationsForFleetArgs,
  VehicleLocations
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRpcLatestLocationsForFleetResponse200 = {
  data: VehicleLocations[]
  status: 200
}

export type getRpcLatestLocationsForFleetResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRpcLatestLocationsForFleetResponseSuccess = (getRpcLatestLocationsForFleetResponse200) & {
  headers: Headers;
};
export type getRpcLatestLocationsForFleetResponseError = (getRpcLatestLocationsForFleetResponseDefault) & {
  headers: Headers;
};

export type getRpcLatestLocationsForFleetResponse = (getRpcLatestLocationsForFleetResponseSuccess | getRpcLatestLocationsForFleetResponseError)

export const getGetRpcLatestLocationsForFleetUrl = (params: GetRpcLatestLocationsForFleetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/rpc/latest_locations_for_fleet?${stringifiedParams}` : `${backendBaseUrl}/rpc/latest_locations_for_fleet`
}

/**
 * @summary Call `latest_locations_for_fleet()`.
 */
export const getRpcLatestLocationsForFleet = async (params: GetRpcLatestLocationsForFleetParams, options?: RequestInit): Promise<getRpcLatestLocationsForFleetResponse> => {

  const res = await fetch(getGetRpcLatestLocationsForFleetUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRpcLatestLocationsForFleetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRpcLatestLocationsForFleetResponse
}


export type postRpcLatestLocationsForFleetResponse200 = {
  data: VehicleLocations[]
  status: 200
}

export type postRpcLatestLocationsForFleetResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postRpcLatestLocationsForFleetResponseSuccess = (postRpcLatestLocationsForFleetResponse200) & {
  headers: Headers;
};
export type postRpcLatestLocationsForFleetResponseError = (postRpcLatestLocationsForFleetResponseDefault) & {
  headers: Headers;
};

export type postRpcLatestLocationsForFleetResponse = (postRpcLatestLocationsForFleetResponseSuccess | postRpcLatestLocationsForFleetResponseError)

export const getPostRpcLatestLocationsForFleetUrl = () => {




  return `${backendBaseUrl}/rpc/latest_locations_for_fleet`
}

/**
 * @summary Call `latest_locations_for_fleet()`.
 */
export const postRpcLatestLocationsForFleet = async (rpcLatestLocationsForFleetArgs: RpcLatestLocationsForFleetArgs, options?: RequestInit): Promise<postRpcLatestLocationsForFleetResponse> => {

  const res = await fetch(getPostRpcLatestLocationsForFleetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rpcLatestLocationsForFleetArgs)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRpcLatestLocationsForFleetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRpcLatestLocationsForFleetResponse
}


